import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=43aa83c3&scoped=true&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminSettings.vue?vue&type=style&index=1&id=43aa83c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aa83c3",
  null
  
)

export default component.exports